import * as _ from 'lodash';
import {Component, ElementRef, forwardRef, Input, OnInit, ViewChild} from '@angular/core';
import {isUndefined} from 'util';
import {Observable} from 'rxjs';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {Subject} from 'rxjs';

declare let Dragdealer: any;


@Component({
  selector: 'app-slider-input',
  templateUrl: './slider-input.component.html',
  styleUrls: ['./slider-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SliderInputComponent),
      multi: true
    }
  ]
})
export class SliderInputComponent implements OnInit, ControlValueAccessor {
  @ViewChild('container') $container: ElementRef;
  redrawSubject = new Subject();
  redraw = this.redrawSubject.debounceTime(10);

  _min: number;
  @Input() set min(min: number) {
    this._min = min;
    this.redrawSubject.next();
  }

  get min(): number {
    return this._min;
  }

  _max: number;
  @Input() set max(max: number) {
    this._max = max;
    this.redrawSubject.next();
  }

  get max(): number {
    return this._max;
  }

  @Input() step: number;

  propagate: (value: number) => void = _.noop;
  drag: any;
  dragging: boolean;

  _value: number;
  set value(value: number) {
    this._value = value;
    this.propagate(value);
  }

  get value(): number {
    return this._value;
  }

  constructor() {
  }

  writeValue(obj: any): void {
    this._value = obj;
    this.resetValue();
  }

  registerOnChange(fn: any): void {
    this.propagate = fn;
  }

  registerOnTouched(fn: any): void {
  }

  async ngOnInit() {
    this.drag = new Dragdealer(this.$container.nativeElement, {
      dragStartCallback: () => this.dragging = true,
      animationCallback: (x: number, y: number) => this.setFromRatio(x),
      dragStopCallback: () => this.dragging = false,
    });
    await Observable.timer(1).toPromise();
    this.redraw.subscribe(() => {
      this.resetValue();
      this.drag.reflow();
    });
  }

  get steps(): number {
    return (this.max - this.min) / this.step;
  }

  resetValue() {
    let ratio;
    if (isUndefined(this.value)) {
      ratio = 0;
    } else {
      ratio = (this.value - this.min) / (this.max - this.min);
    }
    this.drag.setValue(ratio);
  }

  setFromRatio(ratio: number) {
    if (this.step) {
      const multiplier = Math.round(this.steps * ratio);
      this.value = this.min + this.step * multiplier;
    } else {
      this.value = this.min + (this.max - this.min) * ratio;
    }
  }
}
